import { render } from "./PortfolioDetails.vue?vue&type=template&id=642c26af&scoped=true"
import script from "./PortfolioDetails.vue?vue&type=script&lang=js"
export * from "./PortfolioDetails.vue?vue&type=script&lang=js"

import "./PortfolioDetails.vue?vue&type=style&index=0&id=642c26af&lang=scss&scoped=true"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642c26af"]])

export default __exports__